import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import Main from './application/Main.vue'
import { locale } from './application/locale'

//Pages
import ListPage from './application/ListPage.vue'

// Routes
Vue.use(VueRouter)
const routes = [
  { path: '/', component: ListPage },
]
// I18n
Vue.use(VueI18n)

// App
document.addEventListener("DOMContentLoaded", () => {
  const app = document.getElementById('app')
  const pathname = `/${ app.dataset.pathname }` || ""
  const router = new VueRouter({
    base: `/collections${ pathname }`,
    mode: 'history',
    routes,
  })
  const i18n = new VueI18n({
    locale: 'ja',
    messages: locale,
  })

  Vue.prototype.$pathname = pathname

  new Vue({
    render: h => h(Main),
    router,
    i18n,
  }).$mount(app)
})
